const GET_CGU_REQUEST = 'GET_CGU_REQUEST';
const GET_CGU_SUCCESS = 'GET_CGU_SUCCESS';
const GET_CGU_FAILURE = 'GET_CGU_FAILURE';

import * as backend from 'backend-helpers/cgu';

const initState = {
    content: null
};

export default function cgu(state = initState, action) {

    if (action.type === GET_CGU_SUCCESS) {

        return {
            ...state,
            content: action.result.data.content
        };

    }

    return state;
}

export function getCgu() {
    return {
        types: [GET_CGU_REQUEST, GET_CGU_SUCCESS, GET_CGU_FAILURE],
        promise: backend.getCgu()
    }
}


// WEBPACK FOOTER //
// ./src/reducers/cgu.js